import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getData,
  postData,
  deleteData,
  putData,
} from "../../../../services/apiEndpoints";

export const createLiabilityThunk = createAsyncThunk(
  "liabilities/create",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postData(
        "/finance/liabilities/create-liability",
        payload,
      );
      if (!response.success) {
        return rejectWithValue(response.message);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to create liability",
      );
    }
  },
);

export const fetchLiabilitiesThunk = createAsyncThunk(
  "liabilities/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getData("/finance/liabilities/get-liabilities");
      return response;

    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch liabilities",
      );
    }
  },
);

export const fetchSingleLiabilityThunk = createAsyncThunk(
  "liabilities/fetchSingle",
  async (id, { rejectWithValue }) => {
    try {
      const response = await getData(
        `/finance/liabilities/get-liability/${id}`,
      );

      return response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch liability",
      );
    }
  },
);

export const deleteLiabilityThunk = createAsyncThunk(
  "liabilities/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteData(`/finance/liabilities/delete/${id}`);
      if (!response.success) {
        return rejectWithValue(response.message);
      }
      return { id, ...response.data };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to delete liability",
      );
    }
  },
);
export const updateLiabilityThunk = createAsyncThunk(
  "liabilities/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await putData(`/finance/liabilities/update/${id}`, data);
      if (!response.success) {
        return rejectWithValue(response.message);
      }
    
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to update liability",
      );
    }
  },
);

export const addLiabilityPaymentThunk = createAsyncThunk(
  "liabilities/addPayment",
  async ({ liabilityId, payload }, { rejectWithValue }) => {
    try {
      const response = await postData(
        `/finance/liabilities/${liabilityId}/add-payment`,
        payload,
      );
      if (!response.success) {
        return rejectWithValue(response.message);
      }
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to add payment",
      );
    }
  },
);

export const deleteLiabilityPaymentThunk = createAsyncThunk(
  "liabilities/deletePayment",
  async ({ liabilityId, txnId }, { rejectWithValue }) => {
    try {
      const response = await deleteData(
        `/finance/liabilities/${liabilityId}/delete-payment/${txnId}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to delete payment",
      );
    }
  },
);
